const VATStores = ['ES', 'FR', 'GB', 'IE'];

export { VATStores };
